import { useLang } from '@/pages/home/context/LanguageContext';

const industriesPT = [
  {
    title: 'Petróleo & Gás',
    subtitle: 'Manutenção Especializada',
    description: 'Serviços técnicos de alta precisão para refinarias, plataformas e instalações de extração e processamento de petróleo e gás natural.',
    icon: 'ri-fire-line',
    image: 'https://public.readdy.ai/ai/img_res/edited_e195b6a6bc8721fef6106316aac17c55_75933cd6.jpg',
  },
  {
    title: 'Indústria Pesada',
    subtitle: 'Sistemas AVAC Industriais',
    description: 'Soluções completas de climatização e ventilação para fábricas, plantas industriais e instalações de manufatura de grande escala.',
    icon: 'ri-building-2-line',
    image: 'https://public.readdy.ai/ai/img_res/edited_0f1c51d2aae24c2182adc350065bc95b_75933cd6.jpg',
  },
  {
    title: 'Infraestruturas',
    subtitle: 'Manutenção Preventiva',
    description: 'Gestão e manutenção de infraestruturas técnicas críticas, garantindo continuidade operacional e conformidade com normas de segurança.',
    icon: 'ri-community-line',
    image: 'https://readdy.ai/api/search-image?query=Black%20African%20technical%20team%20inspecting%20large%20infrastructure%20facility%20building%20with%20mechanical%20systems%2C%20professional%20engineers%20with%20safety%20equipment%2C%20modern%20industrial%20complex%20exterior&width=800&height=600&seq=ind003&orientation=landscape',
  },
];

const industriesEN = [
  {
    title: 'Oil & Gas',
    subtitle: 'Specialized Maintenance',
    description: 'High-precision technical services for refineries, platforms and oil and natural gas extraction and processing facilities.',
    icon: 'ri-fire-line',
    image: 'https://public.readdy.ai/ai/img_res/edited_e195b6a6bc8721fef6106316aac17c55_75933cd6.jpg',
  },
  {
    title: 'Heavy Industry',
    subtitle: 'Industrial HVAC Systems',
    description: 'Complete air conditioning and ventilation solutions for factories, industrial plants and large-scale manufacturing facilities.',
    icon: 'ri-building-2-line',
    image: 'https://public.readdy.ai/ai/img_res/edited_0f1c51d2aae24c2182adc350065bc95b_75933cd6.jpg',
  },
  {
    title: 'Infrastructure',
    subtitle: 'Preventive Maintenance',
    description: 'Management and maintenance of critical technical infrastructure, ensuring operational continuity and compliance with safety standards.',
    icon: 'ri-community-line',
    image: 'https://readdy.ai/api/search-image?query=Black%20African%20technical%20team%20inspecting%20large%20infrastructure%20facility%20building%20with%20mechanical%20systems%2C%20professional%20engineers%20with%20safety%20equipment%2C%20modern%20industrial%20complex%20exterior&width=800&height=600&seq=ind003&orientation=landscape',
  },
];

const statsPT = [
  { icon: 'ri-award-line', value: '+2', label: 'Anos de Experiência' },
  { icon: 'ri-group-line', value: '30+', label: 'Técnicos Qualificados' },
  { icon: 'ri-map-pin-line', value: 'Nacional', label: 'Cobertura de Serviço' },
  { icon: 'ri-time-line', value: '24/7', label: 'Suporte Técnico' },
];

const statsEN = [
  { icon: 'ri-award-line', value: '+2', label: 'Years of Experience' },
  { icon: 'ri-group-line', value: '30+', label: 'Qualified Technicians' },
  { icon: 'ri-map-pin-line', value: 'National', label: 'Service Coverage' },
  { icon: 'ri-time-line', value: '24/7', label: 'Technical Support' },
];

const headingPT = {
  tag: 'Onde atuamos',
  title: 'Intervenção',
  desc: 'A nossa experiência abrange os setores industriais mais exigentes, onde a segurança e a confiabilidade técnica são inegociáveis.',
};

const headingEN = {
  tag: 'Where we operate',
  title: 'Sectors We Serve',
  desc: 'Our expertise spans the most demanding industrial sectors, where safety and technical reliability are non-negotiable.',
};

export default function IndustriesSection() {
  const { lang } = useLang();
  const industries = lang === 'PT' ? industriesPT : industriesEN;
  const stats = lang === 'PT' ? statsPT : statsEN;
  const h = lang === 'PT' ? headingPT : headingEN;

  return (
    <section id="industries" className="py-24 bg-[#F5F7FA]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <span className="text-[#F97316] text-sm font-semibold uppercase tracking-widest">
            {h.tag}
          </span>
          <h2 className="text-4xl md:text-5xl font-extrabold text-[#0B1A35] mt-2">{h.title}</h2>
          <p className="text-gray-500 text-base max-w-xl mx-auto mt-4 leading-relaxed">{h.desc}</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {industries.map((industry) => (
            <div
              key={industry.title}
              className="relative rounded-2xl overflow-hidden h-80 group cursor-pointer"
            >
              <img
                src={industry.image}
                alt={industry.title}
                className="absolute inset-0 w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0B1A35]/95 via-[#0B1A35]/60 to-[#0B1A35]/20" />
              <div className="absolute inset-0 flex flex-col justify-end p-6">
                <div className="w-10 h-10 flex items-center justify-center bg-[#F97316] rounded-lg mb-3">
                  <i className={`${industry.icon} text-white text-lg`}></i>
                </div>
                <h3 className="text-white font-bold text-xl mb-1">{industry.title}</h3>
                <p className="text-[#F97316] text-xs font-semibold uppercase tracking-wider mb-3">
                  {industry.subtitle}
                </p>
                <p className="text-white/70 text-sm leading-relaxed">{industry.description}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-20 grid grid-cols-2 md:grid-cols-4 gap-8">
          {stats.map((stat) => (
            <div
              key={stat.label}
              className="flex flex-col items-center text-center p-6 bg-white rounded-2xl"
            >
              <div className="w-12 h-12 flex items-center justify-center bg-[#F97316]/10 rounded-xl mb-4">
                <i className={`${stat.icon} text-[#F97316] text-2xl`}></i>
              </div>
              <span className="text-3xl font-extrabold text-[#0B1A35]">{stat.value}</span>
              <span className="text-gray-500 text-sm mt-1">{stat.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
